<modal-hoc
    modalTitle="Designated hosts"
    [submitButton]="false"
    [cancelButton]="false"
    (modalCancel)="onModalCancel($event)">
    <p>This export will always be sent from the following IP addresses:</p>

    @if (!hasError) {
        <div class="ms-5">
            @for (host of hosts; track host) {
                <div>{{host}}</div>
            }
        </div>
    } @else {
        <fdx-alert theme="danger" title="Error" [body]="errorMessage"></fdx-alert>
    }

    @if (loading) {
        <fdx-spinner></fdx-spinner>
    }
</modal-hoc>
